import UploadDocuments from "@/shared/components/common/uploadDocuments";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Dispatch, SetStateAction } from "react";
/**
 * FirstRadio
 *
 * کامپوننت برای بارگذاری تصویر فیش حقوقی کاربر.
 * این کامپوننت شامل:
 * - نمایش توضیحات درباره نوع و محدودیت‌های تصویر مورد نیاز.
 * - استفاده از کامپوننت UploadDocuments برای بارگذاری تصویر.
 * - انتقال تصویر بارگذاری شده به state والد با استفاده از تابع setUploadImageJob.
 *
 * @param {Object} props
 * @param {Dispatch<SetStateAction<any>>} props.setUploadImageJob تابع برای ذخیره تصویر بارگذاری شده در state والد
 *
 * @component
 * @returns JSX.Element
 */

function FirstRadio({setUploadImageJob,}: {setUploadImageJob: Dispatch<SetStateAction<any>>;}) {
  return (
    <StackKit alignItems={"start"} sx={{ width: "100%" }}>
      <TypoGraphyKit variant="h6">
        لطفا تصویر فیش حقوقی را بارگذاری کنید. لطفا تصویر را تا حد امکان با
        کیفیت و در یکی از فرمت های jpg , png, jpeg و حجم حداکثر یک مگابایت
        بارگذاری نمایید.
      </TypoGraphyKit>
      <StackKit direction={"row"} sx={{ width: "100%" }} justifyContent={"center"}>
        <UploadDocuments onUpload={(file: any) => setUploadImageJob(file)} label="بارگذاری عکس فیش حقوقی" defaultImage={"./Legal-advice.png"}/>
      </StackKit>
    </StackKit>
  );
}

export default FirstRadio;
